export default __webpack_public_path__ + "static/media/dipaksingh.3816be92.jpg";